import { isPlainObject } from 'is-plain-object';

// Recursively removes any object keys with a value of undefined
export function removeUndefineds<T>(obj: T): T {
    // @ts-ignore
    if (!isPlainObject(obj)) return obj;

    const target: { [name: string]: any } = {};

    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in obj) {
        const val = obj[key];
        if (typeof val !== 'undefined') {
            target[key] = removeUndefineds(val);
        }
    }

    return target as T;
}

export const getDeviceInfo = async (): Promise<{
    audioInputDevices: MediaDeviceInfo[];
    videoInputDevices: MediaDeviceInfo[];
    audioOutputDevices: MediaDeviceInfo[];
    hasAudioInputDevices: boolean;
    hasVideoInputDevices: boolean;
}> => {
    try {
        await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        const devices = await navigator.mediaDevices.enumerateDevices();

        return {
            audioInputDevices: devices.filter(device => device.kind === 'audioinput'),
            videoInputDevices: devices.filter(device => device.kind === 'videoinput'),
            audioOutputDevices: devices.filter(device => device.kind === 'audiooutput'),
            hasAudioInputDevices: devices.some(device => device.kind === 'audioinput'),
            hasVideoInputDevices: devices.some(device => device.kind === 'videoinput'),
        };
    } catch (error) {
        return {
            audioInputDevices: [],
            videoInputDevices: [],
            audioOutputDevices: [],
            hasAudioInputDevices: false,
            hasVideoInputDevices: false,
        };
    }
};

// This function will return 'true' when the specified permission has been denied by the user.
// If the API doesn't exist, or the query function returns an error, 'false' will be returned.
export async function isPermissionDenied(name: PermissionName) {
    if (navigator.permissions) {
        try {
            const result = await navigator.permissions.query({ name });
            return result.state === 'denied';
        } catch {
            return false;
        }
    } else {
        return false;
    }
}
